// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScaleTicksPipe } from '@coa/app/shared/chart-js/scale-ticks-pipe/scale-ticks.pipe';


@NgModule({
  declarations: [ScaleTicksPipe],
  exports: [ScaleTicksPipe],
  imports: [
    CommonModule,
  ],
})
export class ScaleTicksPipeModule {
}
